<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import api from '@/api';
import SharepointSitesEditForm from '@/components-capability/admin/user-documents/sharepoint-site-edit-form.vue';
import { useSnackbar } from '@/components/common/snackbar/use-snackbar';
import Header from '@/components/layouts/header.vue';
import { SharepointSite } from '@/types';

const initSharepointSites = ref<SharepointSite[]>([]);

const { createSnackbar } = useSnackbar();
const router = useRouter();
const isSubmitting = ref(false);
const submit = async (sites: SharepointSite[]) => {
  try {
    isSubmitting.value = true;
    const sitesForUpdate = sites.map(site => ({
      site_url: site.site_url,
    }));
    await api.putSharepointSites(sitesForUpdate);

    await router.push({ name: 'sharepointIndex' });
  } catch {
    createSnackbar({
      message: 'サイトURLの更新に失敗しました',
      type: 'error',
    });
  } finally {
    isSubmitting.value = false;
  }
};

onMounted(async () => {
  try {
    initSharepointSites.value = await api.getSharepointSites();
  } catch {
    createSnackbar({
      message: 'SharePointサイト情報の取得に失敗しました',
      type: 'error',
    });
  }
});
</script>

<template>
  <div class="sharepoint-site-create">
    <Header title="サイトURL情報" header-width="min(912px, 100%)" is-one-line />
    <SharepointSitesEditForm
      @submit="submit"
      :init-sharepoint-sites="initSharepointSites"
      :is-submitting="isSubmitting"
    />
  </div>
</template>

<style lang="scss" scoped>
.sharepoint-site-create {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  padding: 0 !important;
}
</style>
